import { createAction } from 'redux-actions';
import * as types from './types';

export const foundationsStart = createAction(types.FOUNDATIONS_START);
export const foundationsSuccess = createAction(types.FOUNDATIONS_SUCCESS);
export const foundationsError = createAction(types.FOUNDATIONS_ERROR);
export const foundationsMoreStart = createAction(types.FOUNDATIONS_MORE_START);
export const foundationsMoreSuccess = createAction(types.FOUNDATIONS_MORE_SUCCESS);
export const foundationsRefreshStart = createAction(types.FOUNDATIONS_REFRESH_START);
